import { render, staticRenderFns } from "./tableKeluarga.vue?vue&type=template&id=774592d6&scoped=true"
import script from "./tableKeluarga.vue?vue&type=script&lang=js"
export * from "./tableKeluarga.vue?vue&type=script&lang=js"
import style0 from "./tableKeluarga.vue?vue&type=style&index=0&id=774592d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774592d6",
  null
  
)

export default component.exports